import { useQuery } from "@tanstack/react-query";
import fetcher from "../utils/fetcher";

// Display names for partners (keys are partner IDs from API)
const PARTNER_DISPLAY_NAMES = {
  mojo: "Mojo",
  wiseagent: "Wise Agent",
  topproducer: "Top Producer",
  ilist: "iList",
  marketgenius: "Market Genius",
  "rollout-followupboss": "Follow Up Boss",
  "rollout-lofty": "Lofty",
  "rollout-highlevel": "HighLevel",
  "rollout-boldtrail": "BoldTrail",
};

const usePartners = () => {
  return useQuery({
    queryKey: ["getPartners"],
    queryFn: async () => {
      const resp = await fetcher({
        url: "/api/core/account/partners",
      });
      return resp.data;
    },
    staleTime: Infinity,
    select: (data) => {
      // Transform { id: { credential, enabled, automatic_sync } }
      // into array format for compatibility
      const partnerList = Object.entries(data).map(([id, config]) => ({
        id,
        name: PARTNER_DISPLAY_NAMES[id] || id,
        credential: config.credential || "",
        enabled: config.enabled || false,
        automatic_sync: config.automatic_sync || false,
        isRollout: id.startsWith("rollout-"),
      }));
      return partnerList;
    },
  });
};
export default usePartners;
